import { useRef, useState } from "react";
import { Camera, Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { fileToJpegBase64 } from "@/lib/veeder";
import { useLang } from "@/lib/i18n";
import { METRIC } from "@/lib/units";

// One photo of both end manway lids -> AI estimates the lid-to-lid distance; the driver can still edit it.
export function ManwayPhoto({ onSpacing, t }) {
  const { lang } = useLang();
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true); setMsg(null);
    try {
      const r = await api.scanManway(await fileToJpegBase64(file), lang, METRIC);
      onSpacing(Math.min(90, r.spacing_ft));
      setMsg({ tone: r.confidence === "high" ? "safe" : "caution",
        text: `${t("About {s} ft between the end lids (could be {a}–{b} ft).", { s: r.spacing_ft, a: r.low_ft, b: r.high_ft })} ${r.note || ""} ${t("Pace it off if you can to check.")}` });
    } catch (err) { setMsg({ tone: "danger", text: apiError(err) || t("Couldn't read that photo. Try again.") }); }
    setBusy(false);
  };
  return (
    <div className="manway-photo">
      <input ref={input} type="file" accept="image/*" capture="environment" hidden onChange={pick} data-testid="manway-photo-input" />
      <button type="button" className="ghost-btn manway-btn" disabled={busy} onClick={() => input.current?.click()} data-testid="manway-photo-btn">
        {busy ? <Loader2 size={16} className="spin" /> : <Camera size={16} />}{t("Take a photo of both end lids")}
      </button>
      {msg && <div className={`scan-message tone-${msg.tone}`} data-testid="manway-photo-result">{msg.text}</div>}
    </div>
  );
}
